import React from 'react';
import SingleChoice from './single-choice';
import MultipleChoice from './multiple-choice';
import Textarea from './textarea';
import withStyles from '@mui/styles/withStyles';

const styles = theme => ({});

const Questions = ({
  classes,
  questions,
  answers,
  handleAnswer,
}) => {
  return (
    <>
      {questions.map(question => {
        const value = answers[question.id];
        if (question.questionType === 'SingleSelectQuestion') {
          return (
            <SingleChoice
              key={question.id}
              value={value}
              question={question}
              handler={ e => handleAnswer(question.id, e.target.value)}
            />
          );
        } else if (question.questionType === 'MultiSelectQuestion') {
          return (
            <MultipleChoice
              key={question.id}
              value={answers[question.id]}
              question={question}
              handler={handleAnswer}
            />
          );
        } else {
          return (
            <Textarea
              key={question.id}
              value={answers[question.id]}
              question={question}
              handler={e => handleAnswer(question.id, e.target.value)}
            />
          );
        }
      })}
    </>
  );
};

export default withStyles(styles)(Questions);
